<!-- eslint-disable -->
<template lang="pug">
    .play-box.equation
        template(v-if="!isLoading")
            game-header(
                v-if="!inPuzzle"
                :time="getTime"
                :slug="type"
                gameType="onlineSchool"
                :answers="answers"
                @soundStateChanged="headerKey = !headerKey"
                :key="headerKey"
                :is-homework="!!exerciseId"
            )
            .equation__block(v-if="!counter && isStarted && (!isOlympiad || (isOlympiad && !gameEnd))")
                template(v-if="isTimeOver && !isOlympiad")
                    .equation__reaction-container
                        .equation__reaction
                            .equation__reaction-side.equation__reaction-side--correct
                                div
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                                .equation__reaction-count
                                    | {{ answers.good }}
                            result-image.equation__reaction-image(:status="'success'")
                            .equation__reaction-side.equation__reaction-side--incorrect
                                div
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                                .equation__reaction-count
                                    | {{ answers.bad }}
                        template(v-if="isSingleScreen")
                            .equation__reaction-result_buttons
                                router-link.equation__reaction-result_link(:to="{name: 'dashboard'}")
                                    cs-button.equation__reaction-result_button(pattern="primary-outline" color="blue")
                                        | {{ $i18n.t('common.common_navigation_goToMain') }}
                                slot
                                router-link.equation__reaction-result-link(v-if="!exerciseId" :to="{name: 'trainer:games', params: {gamesType: 'onlineSchool'}}")
                                    cs-button.equation__reaction-result-button(pattern="primary-outline" color="blue")
                                        | {{ $i18n.t('common.common_navigation_goToTrainer') }}
                .equation__container(v-else-if="isRunning")
                    .equation__container-body
                        .equation__number-rules(:class="exampleActionClass")
                            .equation__example-actions
                                .equation__example-action(v-for="(number, index) in numbers")
                                    template(v-if="correctAnswer >= 0 || Math.abs(+number) !== Math.abs(correctAnswer)")
                                        template(v-if="number > 0 && index > 0") &nbsp;+&nbsp;
                                        template(v-else-if="number < 0") &nbsp;-&nbsp;
                                    template(v-else)
                                        template(v-if="number < 0 && index > 0") &nbsp;+&nbsp;
                                        template(v-else-if="number > 0") &nbsp;-&nbsp;
                                    template(v-if="Math.abs(number) === Math.abs(correctAnswer)")
                                        img.equation__emoji(:src="emojiImage")
                                    template(v-else)
                                        | {{ getNumberOutput(number) }}
                                .equation__example-action(v-if="Math.abs(this.equationAnswer) === Math.abs(correctAnswer)")
                                    |  &nbsp;=
                                    img.equation__emoji(:src="emojiImage")
                                .equation__example-action(v-else)
                                    |  &nbsp;= {{ Math.abs(this.equationAnswer) }}
                        .equation__answer-form(v-if="!parameters.dictation")
                            span.equation__answer-text
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_enterTheAnswer') }}
                            .equation__answer-field
                                .equation__answer-left-part
                                    img.equation__emoji(:src="emojiImage")
                                    | =
                                .equation__answer-rigth-part
                                    cs-input.equation__answer-input(
                                        @keyup.native.enter="checkAnswer"
                                        class="equation__input"
                                        maxlength="6"
                                        v-model.number="answer"
                                        v-focus="true"
                                    )
                            .equation__answer-footer
                                cs-button(@click="checkAnswer" color="blue")
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                    game-info(
                        :score="{left: answers.good, right: answers.bad}",
                        :time="getTime",
                        :mode="parameters.mode"
                        :is-olympiad="isOlympiad"
                    )
                template(v-else)
                    .equation__reaction-container
                        .equation__reaction.bad-answer-image
                            result-image.equation__reaction-image(:status="correct ? 'success' : 'failure'")
                        .equation__reaction-result_buttons
                            template(v-if="!gameEnd")
                                cs-button.equation__reaction-result_button.retry-button(
                                    v-if="!correct"
                                    color="blue"
                                    @click="refreshGame"
                                    v-focus="true"
                                )
                                    | {{ $i18n.t('trainer.trainer_games_tryAgain') }}
                                cs-button.equation__reaction-result_button.retry-button(
                                    v-else
                                    color="blue"
                                    @click="refreshGame"
                                    v-focus="true"
                                )
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                            result-buttons(
                                v-else-if="isSingleScreen"
                                :exercise-id="exerciseId"
                                show-restart-button
                                @restartGame="restartGame"
                                games-type="none"
                            )
                                slot
            .equation__prepare-image(v-if="!(gameEnd && parameters.dictation) && !isStarted")
                game-preparation-counter(:counter="counter")
            .equation__show-answer-button(v-if="ableToShowButton && gameEnd && parameters.dictation")
                img.equation__answer-turtle(src="../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg")
                cs-button(pattern="primary-outline" color="blue" @click="showAnswer")
                    | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
            add-and-sub-examples-viewer.equation__viewer(
                v-if="ableToShowAnswer"
                :examplesArray="examplesArray"
                :fractions="parameters.fractions"
                :fractionalPart="parameters.fractionalPart"
            )
        .equation__trainer-loader(v-else-if="isSingleScreen")
            progress(
                :value="this.loadedSound / this.soundObjects.length * 100"
                max="100"
            )
                | {{ this.loadedSound / this.soundObjects.length * 100 }}%
            |  {{ $i18n.t('trainer.trainer_gamePlayBox_gameLoading') }}
</template>

<script>
    /*eslint-disable*/
    import trainerConfig from '../../../../config/trainer';
    import generateOnlineEquation from '../../../../utils/trainer/generateOnlineEquation';
    import GameMixin from '../../../../utils/trainer/game';
    import timer from '../../../../utils/trainer/timer';
    import GameHeader from '../../GameHeader.vue';
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin';
    import AddAndSubExamplesViewer from '../AddAndSubExamplesViewer.vue';
    import GamePreparationCounter from "../../GamePreparationCounter.vue";
    import EndGameMixin from '../utils/endGame';
    import _ from 'lodash';
    import GameInfo from './../GameInfo.vue';
    import ResultImage from '../ResultImage.vue';
    import ResultButtons from '../ResultButtons.vue';
    const SECONDS_IN_MINUTE = 60;
    const EMOJI_AMOUNT = 16;

    function DEFAULT_DATA () {
        return {
            numbers: [],
            correctAnswer: null,
            isRunning: true,
            answer: '',
            correct: null,
            isLoading: false,
            parameters: null,
            gameEnd: false,
            countdownInstance: null,
            resultInstance: null,
            counter: null,
            isStarted: false,
            loadedSound: 0,
            dictationTimer: null,
            dictationTime: 0,
            examplesArray: [],
            examplesPlayed: 0,
            ableToShowAnswer: false,
            ableToShowButton: false,
            emojiImage: null,
            prevEmojiNumber: null,
        }
    }

    export default {
        beforeDestroy () {
            if (!this.inPuzzle) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
        },
        mixins: [generateOnlineEquation, GameMixin, timer, answerDurationMixin, EndGameMixin],
        data() {
            return Object.assign({
                headerKey: false
            }, DEFAULT_DATA())
        },
        props: [
            'exerciseId',
            'type',
            'place',
            'gameType',
            'showTurtle',
            'playersNumber',
            'checkMultiplayerAnswers',
            'playAgain',
            'inPuzzle'
        ],
        mounted() {
            this.isLoading = true;
            this.fetchData()
            .then(() => {
                if (this.playersNumber > 1 || this.inPuzzle) {
                    this.isLoading = false;
                    this.start();
                    return;
                }
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                this.$createjs.Sound.alternateExtensions = ["mp3"];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            });
        },
        watch: {
            isRunning: {
                handler (val) {
                    this.$emit('checkAnswersReady', val);
                },
                immediate: true
            },
            parameters: {
                handler(val) {
                    this.generateEquationNumbers();
                },
                deep: true
            },
            correct(val) {
                this.$emit('playAgainReady', val !== null);
                !this.isOlympiad && this.correctHandler(val);
            },
            answers: {
                handler(val) {
                    if (!this.parameters.timeLimit && !this.parameters.dictation) {
                        if (!this.isOlympiad) {
                            if (val.good >= this.parameters.amountOfExamples) {
                                this.gameEnd = true;
                            }
                        } else {
                            if (val.good + val.bad >= this.parameters.amountOfExamples) {
                                this.gameEnd = true;
                            }
                        }
                    }
                },
                deep: true
            },
            gameEnd (val) {
                if (val) {
                    this.$emit('playAgainReady', false);
                    if (!this.parameters.dictation) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    if (this.inPuzzle) {
                        this.$emit('finish', this.answers, this.time);
                    }
                }
            },
            isTimeOver (val) {
                if (val) {
                    this.gameEnd = true;
                    this.sendStat(false);
                    this.$toasted.info(this.$i18n.t('trainer.trainer_gamePlayBox_gameCompleted'));
                    this.$emit('finish', this.answers, this.time);
                }
            },
            counter (val) {
                if (val > 0) {
                    this.preparation();
                } else {
                    this.isStarted = true;
                    if (!this.timer) {
                        this.setTimer();
                    }
                    if (this.parameters.dictation) {
                        this.startDictationTimer();
                    }
                    if (this.answerDuration) {
                        this.trackTime();
                    }
                }
            },
            checkMultiplayerAnswers (val) {
                if (val && this.isRunning) {
                    this.checkAnswer();
                }
            },
            playAgain (val) {
                if (val
                        && ((this.parameters.amountOfExamples && this.answers.good < this.parameters.amountOfExamples)
                                || (this.parameters.timeLimit && this.time < this.parameters.timeLimit * 60))
                ) {
                    this.refreshGame();
                }
            },
            numbers: {
                handler () {
                    let emojiNumber = null;
                    while (!emojiNumber || emojiNumber === this.prevEmojiNumber) {
                        emojiNumber = Math.floor(Math.random() * EMOJI_AMOUNT);
                    }
                    this.prevEmojiNumber = emojiNumber;
                    this.emojiImage = `/imgs/emoji/${emojiNumber}.svg`;
                },
                immediate: true
            }
        },
        methods: {
            startDictationTimer () {
                this.dictationTimer = setInterval(() => {
                    this.dictationTime++;
                    if (this.dictationTime === this.parameters.timeForAnswer) {
                        this.refreshGame();
                    }
                }, 1000);
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isLoading = false;
                    this.start();
                }
            },
            start() {
                if (this.resultInstance) {
                    this.resultInstance.stop();
                }
                this.counter = 3;
            },
            preparation () {
                if (this.isSingleScreen) {
                    this.countdownInstance = this.$createjs.Sound.play("beep");
                    this.countdownInstance.volume = 0.6;
                }
                setTimeout(() => {
                    this.counter--;
                }, 1000);
            },
            correctHandler (isCorrect) {
                if (isCorrect) {
                    !this.isOlympiad && this.isSingleScreen && this.playResultSound("success");
                    this.answers.good++;
                } else if (isCorrect !== null) {
                    !this.isOlympiad && this.isSingleScreen && this.playResultSound("failure");
                    this.answers.bad++;
                }
            },
            playResultSound(result) {
                if (!this.isSingleScreen) {
                    return;
                }
                this.resultInstance = this.$createjs.Sound.play(result);
                this.resultInstance.volume = 0.6;
            },
            checkAnswer() {
                if (this.answer !== '') {
                    this.$store.commit('setPreviousNumbers', {position: 'first', numbers: this.numbers});
                    this.correct = this.answer === this.correctAnswer;
                    this.isRunning = false;
                    if (!this.parameters.timeLimit) {
                        clearTimeout(this.timer);
                    }
                    if (!this.isOlympiad) {
                        this.isRunning = false;
                    } else {
                        this.correctHandler(this.correct);
                    }
                    if (this.answerDuration) {
                        this.stopTracking();
                    }
                    this.$nextTick(() => {
                        if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                            this.sendStat(this.correct);
                            if (this.isOlympiad) {
                                this.refreshGame();
                            }
                        }
                    });
                }
            },
            refreshGame() {
                if (this.parameters.dictation && this.dictationTime >= this.parameters.timeForAnswer) {
                    this.examplesPlayed++;
                    clearInterval(this.dictationTimer);
                    this.dictationTime = 0;
                    this.examplesArray.push(_.cloneDeep(this.numbers));
                    this.isStarted = false;
                    if (this.examplesPlayed >= this.parameters.amountOfExamples) {
                        this.gameEnd = true;
                        this.ableToShowButton = true;
                        this.isRunning = false;
                    } else {
                        this.generateEquationNumbers();
                        this.counter = 3;
                    }
                    if (!this.ableToShowButton) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    return;
                }
                if (this.isRunning) {
                    return;
                }
                if (this.resultInstance) {
                    this.resultInstance.stop();
                }
                if (this.isOlympiad || this.correct) {
                    this.generateEquationNumbers();
                }
                if (this.answerDuration) {
                    this.trackTime();
                }
                this.correct = null;
                this.answer = '';
                if (!this.parameters.timeLimit) {
                    this.setTimer();
                }
                this.isRunning = true;
            },
            showAnswer() {
                this.ableToShowAnswer = true;
                this.ableToShowButton = false;
                clearTimeout(this.timer);
                this.timer = null;
            },
            getNumberOutput(number) {
                return Math.abs(number);
            },
            restartGame () {
                Object.assign(this, DEFAULT_DATA());
                clearTimeout(this.counterTimeout);
                this.gameStat = null;
                this.answers.good = 0;
                this.answers.bad = 0;
                this.resetTimer();
                this.fetchData();
                this.start();
            }
        },
        computed: {
            isOlympiad () {
                return this.gameType === 'olympiad';
            },
            isSingleScreen () {
                return !this.playersNumber || this.playersNumber === 1;
            },
            exampleActionClass() {
                let largeNumbers = this.parameters.difficult === 'Трехзначные цифры'
                        || this.parameters.difficult === 'Четырехзначные цифры'
                        || this.parameters.difficult === 'Пятизначные цифры'
                        || (this.parameters.fractions && 'Двузначные цифры')
                        || (this.parameters.fractions && this.parameters.difficult === 'Однозначные цифры' && this.parameters.fractionalPart);
                if(largeNumbers && this.numbers.length > 4) {
                    return  'equation__example-action_font-medium'
                }
                return  'equation__example-action_font-big'
                // if (!largeNumbers) {
                //   if (this.numbers.length <= 4) {
                //     return 'equation__example-action--font-x-huge';
                //   }
                //   if (this.numbers.length <= 8) {
                //     return 'equation__example-action--font-big';
                //   }
                //   return 'equation__example-action--font-medium';
                // }
                // if (this.numbers.length <= 3) {
                //   return 'equation__example-action--font-huge';
                // }
                // if (this.numbers.length <= 4) {
                //   return 'equation__example-action--font-big';
                // }
                // if (this.numbers.length <= 5) {
                //   return 'equation__example-action--font-medium';
                // }
                // Uncomment this to make long equations fonts bigger
                // if (this.numbers.length <= 6) {
                //   return 'equation__example-action--font-small';
                // }
                // if (this.numbers.length <= 8) {
                //   return 'equation__example-action--font-tiny';
                // }
                // return 'equation__example-action--font-x-tiny';
                // return 'equation__example-action--font-small';
            },
            isTimeOver() {
                return this.parameters && this.parameters.timeLimit && (this.time >= this.parameters.timeLimit*SECONDS_IN_MINUTE);
            },
            soundObjects() {
                if (!this.isSingleScreen) {
                    return;
                }
                let sounds = [];
                sounds.push(...trainerConfig.result);
                sounds.push(...trainerConfig.countdownSound);
                return sounds;
            },
        },
        components: {
            ResultButtons,
            ResultImage,
            GameHeader,
            AddAndSubExamplesViewer,
            GamePreparationCounter,
            GameInfo
        }
    }
</script>

<style lang="scss" scoped>
    .go-to-trainer-button {
        margin-top: 5px;
    }

    @import "@/assets/sass/games/playbox.scss";

    .equation__block {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        flex-wrap: wrap;
        flex-grow: 1;
        flex-shrink: 1;
        @include inset-space($space-base);
    }

    .equation__container {
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
        height: 100%;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
        @include media($md) {
            flex-direction: row;
        }
        @media screen and (min-width: 576px) and (max-width: 991px) {
            @include inset-space(0);
        }
    }
    .equation__container-body {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
    }
    .equation__number-rules {
        display: flex;
        justify-content: center;
        font-weight: 500;
        @include stack-space($space-large);
    }

    .equation__example-action_font-medium {
        font-size: 22px;
        @include media($sm) {
            font-size: 28px;
        }
        @include media($md) {
            font-size: 32px;
        }
        @include media($xl) {
            font-size: 52px;
        }
        @include media($xxl) {
            font-size: 86px;
        }
    }

    .equation__example-action_font-big {
        font-size: 32px;
        @include media($sm) {
            font-size: 42px;
        }
        @include media($md) {
            font-size: 52px;
        }
        @include media($xl) {
            font-size: 76px;
        }
        @include media($xxl) {
            font-size: 126px;
        }
    }

    .equation__example-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .equation__example-action {
        text-align: center;
        white-space: nowrap;
        font-weight: 500;
        color: $hsl-color-blue-56;
        line-height: 1;
        padding-top: $space-x-small;
        padding-bottom: $space-x-small;
    }

    .equation__emoji {
        width: 0.75em;
        height: 0.75em;
    }

    .equation__answer-form {
        display: flex;
        flex-direction: column;
        align-items: center;

    }

    .equation__answer-text {
        font-size: 22px;
        font-weight: 500;
        @include media ($sm) {
            font-size: 32px;
        }
    }

    .equation__answer-field {
        display: flex;
        align-items: center;
        margin: 20px 0;
        width: 250px;
        @include media ($sm) {
            width: 340px;
        }
    }

    .equation__answer-left-part {
        display: flex;
        align-items: center;
        font-size: 58px;
        font-weight: 500;
        color: $hsl-color-blue-56;
        margin-right: 50px;
        :only-child {
            margin-right: 10px;
        }
        @include media($sm) {
            font-size: 72px;
        }
        @media screen and (max-width: 360px) {
            margin-right: 10px;
        }
    }

    .equation__answer-right-part {
        @include inset-space($space-small);
    }

    .equation__answer-input {
        width: 140px !important;
        height: 50px;
        font-size: 22px !important;
        text-align: center;
        @include media($sm) {
            width: 230px !important;
            height: 60px !important;
        }
        @include media($md) {
            height: 80px !important;
            font-size: 32px !important;
        }
    }

    .equation__answer-footer {
        margin-top: 15px;
        @media screen and (max-width: 767px) {
            margin-right: 25px;
        }
    }

    .equation__reaction-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
    }

    .equation__reaction {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        @include stack-space($space-base);
        flex-direction: row;
        @include media($md) {
            flex-wrap: nowrap;
        }
        @media screen and (max-width: 655px) {
            justify-content: space-between;
        }
    }

    .equation__reaction-side {
        align-self: normal;
        font-weight: 500;
        font-size: 20px;
        @include media($sm) {
            width: auto;
            font-size: 28px;
        }
        @include media($md) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            flex-grow: 1;
            align-self: center;
            font-size: 20px;
        }
        @media screen and ($md) and (max-width: 800px) {
            font-size: 18px;
        }
        @include media($lg) {
            font-size: 32px;
        }
        @include media($xlg) {
            font-size: 42px;
        }
        color: $hsl-color-green-58;
        @include stack-space($space-base);
        @include media($sm) {
            @include stack-space(0);
        }
        @media screen and (max-width: 768px) {
            width: 50%;
        }

        &:first-child {
            @media screen and (max-width: 767px) {
                order: 1;
            }
        }

        &:last-child {
            @media screen and (max-width: 767px) {
                order: 2
            }
        }
    }

    .equation__reaction-side--correct {
        color: $hsl-color-green-58;
    }

    .equation__reaction-side--incorrect {
        color: $hsl-color-red-62;
    }

    .equation__reaction-image {
        @include stack-space($space-base);
        @media screen and (max-width: 767px) {
            order: 3;
            margin: 0 auto;
        }
    }

    .equation__reaction-result_buttons {
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .equation__reaction-result_link {
        @media screen and (max-width: 640px) {
            display: block;
            width: 100%;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .equation__reaction-result_button {
        @media screen and (max-width: 640px) {
            width: 100%;
        }
    }

    .equation__show-answer-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .equation__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .equation__prepare-image {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
    }

    .equation__trainer-loader {
        @include make-col(8, 12, 0);
        @include make-offset(2, 12);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        height: 100%;
    }

    .equation__viewer {
        @include inset-space($space-base);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
        flex-shrink: 1;
    }


    .bad-answer-image {
        justify-content: center;
    }

    .retry-button {
        width: auto;
    }

    .game-info {
        align-self: flex-end;
        @include media ($md) {
            align-self: flex-start
        }
    }

    //.multi-screen {
    //    .equation {
    //        &__reaction-image-container {
    //            display: none;
    //        }
    //        &__reaction-image {
    //            max-height: 300px;
    //        }
    //        &__number-rules {
    //            @include media-breakpoint-between(xs, sm) {
    //                @include stack-space($space-x-small);
    //            }
    //        }
    //        &__example-action {
    //            &--font-x-huge {
    //              font-size: 5.5vh;
    //              @include media($sm) {
    //                font-size: 7.5vh;
    //              }
    //              @include media($lg) {
    //                font-size: 6.5vh;
    //              }
    //              @include media($xlg) {
    //                font-size: 7vh;
    //              }
    //            }
    //            &--font-huge {
    //              font-size: 4vh;
    //              @include media($sm) {
    //                font-size: 6vh;
    //              }
    //              @include media($lg) {
    //                font-size: 5vh;
    //              }
    //              @include media($xlg) {
    //                font-size: 6vh;
    //              }
    //            }
    //            &--font-big {
    //              font-size: 3.5vh;
    //              @include media($sm) {
    //                font-size: 5.5vh;
    //              }
    //              @include media($lg) {
    //                font-size: 4.5vh;
    //              }
    //              @include media($xlg) {
    //                font-size: 5.5vh;
    //              }
    //            }
    //            &--font-medium {
    //              font-size: 3.5vh;
    //              @include media($sm) {
    //                font-size: 5vh;
    //              }
    //              @include media($lg) {
    //                font-size: 4vh;
    //              }
    //              @include media($xlg) {
    //                font-size: 5vh;
    //              }
    //            }
    //            &--font-small {
    //              font-size: 3vh;
    //              @include media($sm) {
    //                font-size: 5vh;
    //              }
    //              @include media($lg) {
    //                font-size: 4vh;
    //              }
    //            }
    //            &--font-tiny {
    //              font-size: 3vh;
    //              @include media($sm) {
    //                font-size: 4vh;
    //              }
    //              @include media($lg) {
    //                font-size: 3.5vh;
    //              }
    //            }
    //            &--font-x-tiny {
    //              font-size: 3vh;
    //              @include media($sm) {
    //                font-size: 3.5vh;
    //              }
    //              @include media($lg) {
    //                font-size: 3vh;
    //              }
    //            }
    //        }
    //        &__answer-header {
    //            @include text(60px);
    //        }
    //        &__input {
    //            width: 180px;
    //            @include text($font-size-32, $font-weight-bold);
    //        }
    //        &__reaction {
    //            @include media($lg){
    //                flex-direction: column;
    //            }
    //        }
    //        &__reaction-side {
    //            @include text($font-size-20);
    //            @include stack-space($space-base);
    //            @include media($lg){
    //                @include make-col(12, 12, 0);
    //                @include stack-space($space-base);
    //            }
    //        }
    //        &__reaction-count {
    //            @include text($font-size-44, $font-weight-bold);
    //        }
    //    }
    //}
    //
    //.four-screen {
    //    .equation {
    //        &__reaction-image {
    //            max-height: 180px;
    //        }
    //        &__number-rules {
    //            @include stack-space($space-x-small);
    //        }
    //    }
    //}
</style>
